import { ModelFactory } from "../../ModelFactory";

export class HistoricDomainPrice {
  constructor(
    public readonly tld: string,
    public readonly price: number,
    public readonly period: number,
    public readonly priceType: 'renewal' | 'registration' | 'transfer',
    public readonly provider: string,
    public readonly date: Date,
  ) {
  }
}

class HistoricDomainPriceFactory extends ModelFactory<HistoricDomainPrice> {
  protected fromJson(json: any): HistoricDomainPrice {
    return new HistoricDomainPrice(
      json['tld'],
      json['price'],
      json['period'],
      json['price_type'],
      json['provider'],
      new Date(json['date']),
    );
  }
}
export const historicDomainPriceFactory = new HistoricDomainPriceFactory();
